<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Real-Time (SignalR) Events</h5>
          <div class="ibox-tools">
            <div class="btn-group">
              <button type="button" class="btn btn-xs btn-outline btn-primary" (click)="testNotification()"
                [disabled]="!isConnected()" title="Send a test scoring event">
                <i class="fa fa-pencil-square-o"></i> Test Scoring
              </button>
              <button type="button" class="btn btn-xs btn-outline btn-primary" (click)="testTournamentNotification()"
                [disabled]="!isConnected()" title="Send a test tournament event">
                <i class="fa fa-trophy"></i> Test Tournament
              </button>
              <button type="button" class="btn btn-xs btn-outline btn-primary" (click)="testRoundNotification()"
                [disabled]="!isConnected()" title="Send a test round event">
                <i class="fa fa-hourglass"></i> Test Round
              </button>
            </div>
            <button type="button" class="btn btn-xs btn-outline btn-success" (click)="startListening()"
              [disabled]="!isConnected() || isListening()" title="Start listening to events">
              <i class="fa fa-play"></i> Start Listening
            </button>
            <button type="button" class="btn btn-xs btn-outline btn-danger" (click)="stopListening()"
              [disabled]="!isConnected() || !isListening()" title="Stop listening to events">
              <i class="fa fa-stop"></i> Stop Listening
            </button>
            <button type="button" class="btn btn-xs btn-outline btn-info" (click)="attemptTransportUpgrade()"
              [disabled]="!isConnected() || transportOptimality().level === 'optimal'"
              title="Test for better transport">
              <i class="fa fa-arrow-up"></i> Upgrade Transport
            </button>
            <button type="button" class="btn btn-xs btn-outline btn-warning" (click)="clearAllEvents()"
              title="Clear event history">
              <i class="fa fa-eraser"></i> Clear Buffer
            </button>
          </div>
        </div>
        <div class="ibox-content">
          <!-- Connection Status -->
          <div class="mb-3">
            <div class="row">
              <div class="col-md-4">
                <strong>Connection Status:</strong>
                <span [class.text-success]="isConnected()" [class.text-danger]="!isConnected()">
                  {{ isConnected() ? 'Connected' : 'Disconnected' }}
                </span>
              </div>
              <div class="col-md-5">
                <strong>Transport:</strong>
                <span [ngClass]="transportOptimality().color">
                  {{ transportType() }}
                </span>
                @if (isConnected()) {
                <small class="text-muted d-block">{{ transportOptimality().description }}</small>
                }
              </div>
              <div class="col-md-3">
                <div class="mb-2">
                  <strong>Subscription Mode:</strong>
                  <span class="badge badge-success">
                    <i class="fa fa-eye"></i> ALL Events
                  </span>
                </div>
                @if (isConnected() && transportOptimality().level !== 'optimal') {
                <button type="button" class="btn btn-xs btn-outline btn-info" (click)="attemptTransportUpgrade()"
                  title="Test for better transport">
                  <i class="fa fa-arrow-up"></i> Test Upgrade
                </button>
                }
              </div>
            </div>
          </div>

          <!-- Event Statistics -->
          <div class="row mb-4">
            <div class="col-md-2">
              <div class="form-group">
                <label>Total Events:</label>
                <span class="form-control-static text-info">
                  <strong>{{ totalEventsReceived() + totalTournamentEventsReceived() + totalRoundEventsReceived()
                    }}</strong>
                </span>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Events in Buffer:</label>
                <span class="form-control-static text-primary">
                  <strong>{{ totalEventCount() }}</strong> / 1000
                </span>
                <small class="text-muted d-block">
                  Scoring: {{ scoringEventCount() }} | Tournament: {{ tournamentEventCount() }} | Round: {{
                  roundEventCount() }}
                </small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Last Event:</label>
                <span class="form-control-static" [class.text-success]="lastEventReceivedOverall()"
                  [class.text-muted]="!lastEventReceivedOverall()">
                  {{ lastEventReceivedOverall() ? (lastEventReceivedOverall() | date:'medium') : 'No events received' }}
                </span>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Connection:</label>
                <span class="form-control-static" [class.text-success]="isConnected()"
                  [class.text-danger]="!isConnected()">
                  <i class="fa" [class.fa-circle]="isConnected()" [class.fa-circle-o]="!isConnected()"></i>
                  {{ isConnected() ? 'Online' : 'Offline' }}
                </span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Listening Status:</label>
                <span class="form-control-static" [class.text-success]="isListening()"
                  [class.text-warning]="!isListening()">
                  <i class="fa" [class.fa-volume-up]="isListening()" [class.fa-volume-off]="!isListening()"></i>
                  {{ isListening() ? 'Listening' : 'Not Listening' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Recent Events List -->
          <div class="form-group">
            <label>Recent Events
              @if (totalEventCount() > 10) {
              <small class="text-muted">(scroll to see all {{ totalEventCount() }} events)</small>
              } @else {
              <small class="text-muted">(up to 1000 events stored)</small>
              }
            </label>
            @if (!hasEvents()) {
            <div class="well text-center text-muted">
              <i class="fa fa-info-circle"></i>
              <p>No events received yet.</p>
              @if (isConnected() && isListening()) {
              <small>Connection is active and listening for events...</small>
              } @else if (isConnected() && !isListening()) {
              <small>Connection is active but not listening for events. Click "Start Listening" to begin.</small>
              } @else {
              <small>Connection is not active. Events will appear when connected and listening.</small>
              }
            </div>
            } @else {
            <!-- Event Type Tabs -->
            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs" role="tablist">
                <li [class.active]="activeTab() === 'scoring'">
                  <a role="tab"
                     [attr.aria-selected]="activeTab() === 'scoring'"
                     href="javascript:void(0)"
                     (click)="setActiveTab('scoring')">
                    <i class="fa fa-pencil"></i> Scoring Events
                    <span class="badge badge-primary">{{ scoringEventCount() }}</span>
                  </a>
                </li>
                <li [class.active]="activeTab() === 'tournament'">
                  <a role="tab"
                     [attr.aria-selected]="activeTab() === 'tournament'"
                     href="javascript:void(0)"
                     (click)="setActiveTab('tournament')">
                    <i class="fa fa-trophy"></i> Tournament Events
                    <span class="badge badge-info">{{ tournamentEventCount() }}</span>
                  </a>
                </li>
                <li [class.active]="activeTab() === 'round'">
                  <a role="tab"
                     [attr.aria-selected]="activeTab() === 'round'"
                     href="javascript:void(0)"
                     (click)="setActiveTab('round')">
                    <i class="fa fa-clock-o"></i> Round Events
                    <span class="badge badge-warning">{{ roundEventCount() + roundOfficialEventCount() }}</span>
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <!-- Scoring Events Tab -->
                @if (activeTab() === 'scoring') {
                <div class="tab-pane active">
                  @if (recentScoringEvents().length === 0) {
                  <div class="well text-center text-muted">
                    <i class="fa fa-golf-ball-o"></i>
                    <p>No scoring events received yet.</p>
                  </div>
                  } @else {
                  <div class="events-container">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>Timestamp</th>
                            <th>Event Type</th>
                            <th>Scorecard ID</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (event of recentScoringEvents(); track event.scorecardId + event.timestamp) {
                          <tr>
                            <td>
                              {{ event.timestamp | date:'medium' }}
                            </td>
                            <td>
                              <span class="badge" [class.badge-success]="event.type === 'ScorecardCreated'"
                                [class.badge-info]="event.type === 'ScorecardUpdated'"
                                [class.badge-warning]="event.type === 'ScorecardMarkedOfficial'"
                                [class.badge-default]="event.type === 'ScorecardMarkedNotOfficial'">
                                {{ event.type }}
                              </span>
                            </td>
                            <td>
                              <code>{{ event.scorecardId }}</code>
                            </td>
                            <td>
                              <div class="btn-group">
                                <button type="button" class="btn btn-xs btn-default"
                                  title="Copy Scorecard ID to clipboard" (click)="copyToClipboard(event.scorecardId)">
                                  <i class="fa fa-copy"></i>
                                </button>
                                <button type="button" class="btn btn-xs btn-info" title="Toggle JSON view"
                                  (click)="toggleEventJson(event)">
                                  <i class="fa" [class.fa-expand]="!isEventJsonExpanded(event)"
                                    [class.fa-compress]="isEventJsonExpanded(event)"></i>
                                  JSON
                                </button>
                                @if (isEventJsonExpanded(event)) {
                                <button type="button" class="btn btn-xs btn-success" title="Copy JSON to clipboard"
                                  (click)="copyEventJson(event)">
                                  <i class="fa fa-copy"></i>
                                  Copy JSON
                                </button>
                                }
                              </div>
                            </td>
                          </tr>
                          @if (isEventJsonExpanded(event)) {
                          <tr>
                            <td colspan="4">
                              <div class="json-display">
                                <label><strong>Complete Event JSON:</strong></label>
                                <pre class="json-content">{{ getEventJson(event) }}</pre>
                              </div>
                            </td>
                          </tr>
                          }
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  }
                </div>
                }

                <!-- Tournament Events Tab -->
                @if (activeTab() === 'tournament') {
                <div class="tab-pane active">
                  @if (recentTournamentEvents().length === 0) {
                  <div class="well text-center text-muted">
                    <i class="fa fa-trophy"></i>
                    <p>No tournament events received yet.</p>
                  </div>
                  } @else {
                  <div class="events-container">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>Timestamp</th>
                            <th>Event Type</th>
                            <th>Tournament ID</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (event of recentTournamentEvents(); track event.tournamentId + event.timestamp) {
                          <tr>
                            <td>
                              {{ event.timestamp | date:'medium' }}
                            </td>
                            <td>
                              <span class="badge" [class.badge-success]="event.type === 'TournamentMarkedActive'"
                                [class.badge-danger]="event.type === 'TournamentMarkedNotActive'">
                                {{ event.type }}
                              </span>
                            </td>
                            <td>
                              <code>{{ event.tournamentId }}</code>
                            </td>
                            <td>
                              <span [class.text-success]="event.active" [class.text-danger]="!event.active">
                                <i class="fa" [class.fa-check-circle]="event.active"
                                  [class.fa-times-circle]="!event.active"></i>
                                {{ event.active ? 'Active' : 'Not Active' }}
                              </span>
                              @if (event.activeOnUtc) {
                              <small class="text-muted d-block">
                                Active since: {{ event.activeOnUtc | date:'medium' }}
                              </small>
                              }
                            </td>
                            <td>
                              <div class="btn-group">
                                <button type="button" class="btn btn-xs btn-default"
                                  title="Copy Tournament ID to clipboard" (click)="copyToClipboard(event.tournamentId)">
                                  <i class="fa fa-copy"></i>
                                </button>
                                <button type="button" class="btn btn-xs btn-info" title="Toggle JSON view"
                                  (click)="toggleTournamentEventJson(event)">
                                  <i class="fa" [class.fa-expand]="!isTournamentEventJsonExpanded(event)"
                                    [class.fa-compress]="isTournamentEventJsonExpanded(event)"></i>
                                  JSON
                                </button>
                                @if (isTournamentEventJsonExpanded(event)) {
                                <button type="button" class="btn btn-xs btn-success" title="Copy JSON to clipboard"
                                  (click)="copyTournamentEventJson(event)">
                                  <i class="fa fa-copy"></i>
                                  Copy JSON
                                </button>
                                }
                              </div>
                            </td>
                          </tr>
                          @if (isTournamentEventJsonExpanded(event)) {
                          <tr>
                            <td colspan="5">
                              <div class="json-display">
                                <label><strong>Complete Tournament Event JSON:</strong></label>
                                <pre class="json-content">{{ getTournamentEventJson(event) }}</pre>
                              </div>
                            </td>
                          </tr>
                          }
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  }
                </div>
                }

                <!-- Round Events Tab -->
                @if (activeTab() === 'round') {
                <div class="tab-pane active">
                  @if (combinedRoundEvents().length === 0) {
                  <div class="well text-center text-muted">
                    <i class="fa fa-clock-o"></i>
                    <p>No round events received yet.</p>
                  </div>
                  } @else {
                  <div class="events-container">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>Timestamp</th>
                            <th>Event Type</th>
                            <th>Round ID</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (event of combinedRoundEvents(); track event.roundId + event.timestamp) {
                          <tr>
                            <td>
                              {{ event.timestamp | date:'medium' }}
                            </td>
                            <td>
                              <span class="badge" 
                                [class.badge-success]="event.type === 'RoundMarkedActive' || event.type === 'RoundMarkedOfficial'"
                                [class.badge-danger]="event.type === 'RoundMarkedNotActive' || event.type === 'RoundMarkedNotOfficial'">
                                {{ event.type }}
                              </span>
                            </td>
                            <td>
                              <code>{{ event.roundId }}</code>
                            </td>
                            <td>
                              @if (event.category === 'active') {
                              <span [class.text-success]="event.active" [class.text-danger]="!event.active">
                                <i class="fa" [class.fa-check-circle]="event.active"
                                  [class.fa-times-circle]="!event.active"></i>
                                {{ event.active ? 'Active' : 'Not Active' }}
                              </span>
                              @if (event.activeOnUtc) {
                              <small class="text-muted d-block">
                                Active since: {{ event.activeOnUtc | date:'medium' }}
                              </small>
                              }
                              } @else {
                              <span [class.text-success]="event.official" [class.text-danger]="!event.official">
                                <i class="fa" [class.fa-certificate]="event.official"
                                  [class.fa-times-circle]="!event.official"></i>
                                {{ event.official ? 'Official' : 'Not Official' }}
                              </span>
                              @if (event.officialOnUtc) {
                              <small class="text-muted d-block">
                                Official since: {{ event.officialOnUtc | date:'medium' }}
                              </small>
                              }
                              }
                            </td>
                            <td>
                              <div class="btn-group">
                                <button type="button" class="btn btn-xs btn-default" title="Copy Round ID to clipboard"
                                  (click)="copyToClipboard(event.roundId)">
                                  <i class="fa fa-copy"></i>
                                </button>
                                <button type="button" class="btn btn-xs btn-info" title="Toggle JSON view"
                                  (click)="toggleRoundEventJson(event)">
                                  <i class="fa" [class.fa-expand]="!isRoundEventJsonExpanded(event)"
                                    [class.fa-compress]="isRoundEventJsonExpanded(event)"></i>
                                  JSON
                                </button>
                                @if (isRoundEventJsonExpanded(event)) {
                                <button type="button" class="btn btn-xs btn-success" title="Copy JSON to clipboard"
                                  (click)="copyRoundEventJson(event)">
                                  <i class="fa fa-copy"></i>
                                  Copy JSON
                                </button>
                                }
                              </div>
                            </td>
                          </tr>
                          @if (isRoundEventJsonExpanded(event)) {
                          <tr>
                            <td colspan="5">
                              <div class="json-display">
                                <label><strong>Complete Round Event JSON:</strong></label>
                                <pre class="json-content">{{ getRoundEventJson(event) }}</pre>
                              </div>
                            </td>
                          </tr>
                          }
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }

            <!-- Info Box -->
            <div class="alert alert-info">
              <i class="fa fa-info-circle"></i>
              <strong style="margin:0px 5px;">Real-Time Events:</strong>
              This displays <strong>ALL</strong> real-time events received through SignalR, including scoring,
              tournament, and round events.
              <strong>Scoring events</strong> include scorecard updates, creation, and official status changes.
              <strong>Tournament events</strong> include tournament activation and deactivation.
              <strong>Round events</strong> include round activation and deactivation.
              Up to 1000 events are stored here in memory; use the tabs above to switch between event types.
              <br><br>
              <i class="fa fa-eye"></i>
              <strong style="margin:0px 5px;">Event Monitoring:</strong>
              This page subscribes to <strong>ALL SignalR events</strong> for comprehensive monitoring.
              When you navigate to Scores/Stats/Verify pages, those components will automatically subscribe to
              group-specific events only.
              <br><br>
              <i class="fa fa-info-circle"></i>
              <strong style="margin:0px 5px;">Transport Types:</strong>
              <span class="text-success">WebSockets (Optimal)</span> - Best performance with bi-directional
              communication.
              <span class="text-info">Server-Sent Events (Efficient)</span> - Good performance with server-to-client
              streaming.
              <span class="text-warning">Long Polling (Fallback)</span> - Basic compatibility mode with higher latency.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>